import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface CustomerRatingOption {
  value: number
  label: string
}

function useCustomerRatingOptions() {
  const intl = useIntl()

  return useMemo(() => {
    const GOOD: CustomerRatingOption = {
      value: 7,
      label: intl.formatMessage({
        id: 'N0G_hPr37e_uGSPteMSe',
        defaultMessage: 'Good: 7.0+',
      }),
    }

    const VERY_GOOD: CustomerRatingOption = {
      value: 8,
      label: intl.formatMessage({
        id: 'l2oLdn3EJvAXmeYFE8Sa',
        defaultMessage: 'Very good: 8.0+',
      }),
    }

    const EXCEPTIONAL: CustomerRatingOption = {
      value: 9,
      label: intl.formatMessage({
        id: 'NXvDTZwJvm5B7LA10P6s',
        defaultMessage: 'Exceptional: 9.0+',
      }),
    }

    const ANY_RATING: CustomerRatingOption = {
      value: 0,
      label: intl.formatMessage({
        id: '3Qw2JpuFZ0dOohUoA8LN',
        defaultMessage: 'Any rating',
      }),
    }

    const CUSTOMER_RATING_GTE: Record<string, CustomerRatingOption> = {
      GOOD,
      VERY_GOOD,
      EXCEPTIONAL,
      ANY_RATING,
    }

    const CUSTOMER_RATING_GTE_BY_VALUE: Record<string, CustomerRatingOption> = {
      7: GOOD,
      8: VERY_GOOD,
      9: EXCEPTIONAL,
    }

    return {
      CUSTOMER_RATING_GTE,
      CUSTOMER_RATING_GTE_BY_VALUE,
    }
  }, [intl])
}

export default useCustomerRatingOptions
